import Pusher from 'pusher-js';

import { EventChannel, eventChannel } from 'redux-saga';
import { ITaskSocketAction } from '../../page/page-storage/tasks/tasks.types';
import humps from 'lodash-humps-ts';

export type ISocketAction = ITaskSocketAction;

export interface IPusherEvent {
  message: string;
}

export interface IPusherAction {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
}

Pusher.logToConsole = true;

// SINGLETON, we don't need multiple instances of this
export const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY || '', {
  cluster: process.env.REACT_APP_PUSHER_CLUSTER || '',
});

/**
 * Creates a Redux Saga Event Channel to hook on the Pusher Channel events received
 * @param channelName The name of the Pusher channel
 * @param actionNames Actions to bind/monitor in the Pusher channel
 * @returns An Redux EventChannel
 */
export function createSagaEventChannelForPusherChannel(
  channelName: string,
  actionNames: string[],
): EventChannel<IPusherAction> {
  return eventChannel((emit) => {
    const messageReceivedHandler = (actionName: string, event: IPusherEvent) => {
      // "humps" converts all props of object to camelCase
      emit(humps(event.message));
    };

    const pusherChannel = pusher.subscribe(channelName);
    actionNames.forEach((actionName) => pusherChannel.bind(actionName, messageReceivedHandler.bind(null, actionName)));

    const unsubscribe = () => {
      actionNames.forEach((actionName) => pusherChannel.unbind(actionName));
    };

    return unsubscribe;
  });
}
